module.exports = __webpack_public_path__ + "static/media/productImageNotFound.fd5abed1.png";